import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        container: '[js-site-nav="container"]',
        opener: '[js-site-nav="opener"]',
        close: '[js-site-nav="close"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initNav()
    }

    function initNav() {
        $(document).keyup(function(e) {
            if (e.key === "Escape") {
                closeNav();
            }
        });

        $(nodeSelectors.opener).on('click', openNav)

        $(nodeSelectors.close).on('click', closeNav)
    }

    function openNav() {
        $(nodeSelectors.container).addClass('active')
        $('html, body').addClass('no-scroll')
    }

    function closeNav() {
        $(nodeSelectors.container).removeClass('active')
        $('html, body').removeClass('no-scroll')
    }

    return Object.freeze({
        init,
    })
}